import { render, staticRenderFns } from "./PermissionMatrixTable.vue?vue&type=template&id=3ee36b5a&scoped=true"
import script from "./PermissionMatrixTable.vue?vue&type=script&lang=js"
export * from "./PermissionMatrixTable.vue?vue&type=script&lang=js"
import style0 from "./PermissionMatrixTable.vue?vue&type=style&index=0&id=3ee36b5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee36b5a",
  null
  
)

export default component.exports